import submitKeymap from './plugins/keymap';

const submit = {

	plugins(options) {

		return [submitKeymap(options.onSubmit, options.chatView)];

	},

};

export default submit;
